import { render, staticRenderFns } from "./ticklist.vue?vue&type=template&id=d25fc8b4&scoped=true"
import script from "./ticklist.vue?vue&type=script&lang=js"
export * from "./ticklist.vue?vue&type=script&lang=js"
import style0 from "./ticklist.vue?vue&type=style&index=0&id=d25fc8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25fc8b4",
  null
  
)

export default component.exports